// extracted by mini-css-extract-plugin
export default {"scrollBtn":"ScrollTopBtn_scrollBtn__dOKy3"};